import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import { takeWhile } from 'rxjs/operators';
import { TicketManager } from '@routes/ticket-manager';
import { Ticket } from '@routes/ticket-manager/ticket';
import { AuthService } from '@core/auth/auth.service';
import { TicketLogChannel } from '@shared/enums/ticket-log';
import { ApiService } from '@shared/apis';

@Component({
  selector: 'app-conversation',
  templateUrl: './conversation.component.html',
  styleUrls: ['./conversation.component.scss']
})
export class ConversationComponent implements OnInit, OnDestroy {

  readonly ticketLogChannel = TicketLogChannel;

  ticketLogs: any[] = [];

  ticket: Ticket;

  userInfo: any = {};
  loading: boolean = true;

  subscription: any = {};
  @ViewChild('perfectScroll') perfectScroll: PerfectScrollbarComponent;
  private alive = true;


  constructor(public ticketManager: TicketManager,
              private apiService: ApiService,
              private authService: AuthService,) {
  }

  ngOnInit(): void {
    this.userInfo = this.authService.getUser();

    this.subscription.ticketEdit = this.ticketManager.activeTicket$
      .pipe(takeWhile(() => this.alive))
      .subscribe(ticket => {
        if (!ticket) {
          return;
        }

        if (ticket.ticketInfo.status === 'new') {
          this.loading = false;
        }

        if (this.subscription.ticketEdit) {
          this.subscription.ticketEdit.unsubscribe();
          return;
        }

        this.ticket = ticket;
        ticket.conversation$.subscribe(res => {
          if (!res) {
            return;
          }
          this.ticketLogs = res.map(f => {
            f.my = f.createdBy === this.userInfo.key;
            f.log = f.log.replaceAll('\n', '<br>');
            return f;
          });

          const params = {
            ticketNo: ticket.ticketInfo.ticketNo,
            company: this.authService.getCurrentCompany()
          }
          this.loading = true;

          try {
            this.apiService.ticket.getTicketLogs(params)
              .subscribe(res => {
                if (res.success) {
                  res?.messageTab.map(f => {
                    this.ticketLogs.push(f);
                    this.ticketLogs.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
                  });
                }
                this.loading = false;
              }, err => {
                this.loading = false;
              });
          } catch (e) {
            this.loading = false;
          }


          this.scrollToBottom();
        });
      });

    this.scrollToBottom();
  }

  ngOnDestroy() {
    this.alive = false;
  }

  scrollToBottom() {
    setTimeout(() => {
      this.perfectScroll.directiveRef.scrollToBottom(0, 300);
      // this.perfectScroll.directiveRef.scrollToTop(0, 300);
    });
  }

}
